require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-five-reasons-why-code-fellows-is-now-teaching-java.json") })
        }
      }, "path---blog-five-reasons-why-code-fellows-is-now-teaching-java");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-five-reasons-why-code-fellows-is-now-teaching-java!./.cache/json/blog-five-reasons-why-code-fellows-is-now-teaching-java.json
// module id = 806
// module chunks = 231608221292675